import '../themeDefaults';

export default ({
  formComponents
}) => ({
  root: {
    color: ({ dark, hasError, warning }) => {
      if (hasError) {
        return dark
          ? (
            warning
              ? formComponents.dark.warning.borderColor
              : formComponents.dark.error.borderColor
          )
          : (
            warning
              ? formComponents.warning.borderColor
              : formComponents.error.borderColor
          );
      }

      return (dark ? formComponents.dark.color : formComponents.label.color);
    },
    fontFamily: formComponents.optionalSpanFontFamily,
    fontSize: formComponents.optionalSpanFontSize,
    lineHeight: ({ withTextarea }) => {
      const pixels = withTextarea
        ? formComponents.input.textareaHeight
        : formComponents.input.height;
      return `${pixels}px`;
    },
    marginLeft: 5,
    textTransform: 'lowercase'
  }
});
